import { useCallback, useEffect, useState } from 'react'

/**
 * fixedなコンテンツを表示する時に画面がスクロールしないように制御する関数を提供するhooks
 */
export const useLockScrollingBackContent = () => {
  const [isLockScrollingBackContent, setIsLockScrollingBackContent] =
    useState(false)
  /**
   * 画面がスクロールしないように固定する関数
   */
  const lockScrollingBackContent = useCallback(() => {
    setIsLockScrollingBackContent(true)
    // fixedな要素を表示するときにスクロールしないように画面を固定する処理
    document.body.style.overflow = 'hidden'
    // iOSデバイス向けの処理
    document.documentElement.style.overflow = 'hidden'
  }, [])

  /**
   * 画面の固定を解除する関数
   */
  const unlockScrollingBackContent = useCallback(() => {
    document.body.style.overflow = 'auto'
    // iOSデバイス向けの処理
    document.documentElement.style.overflow = 'auto'
  }, [])

  useEffect(() => {
    return () => {
      isLockScrollingBackContent && unlockScrollingBackContent()
    }
  })

  return { lockScrollingBackContent, unlockScrollingBackContent }
}
